module.exports = __webpack_public_path__ + "static/media/hero.ae74261d.svg";